var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5625 0C43.5 0 48 4.5 48 11.4375V36.5625C48 43.5 43.5 48 36.5625 48H11.4375C4.5 48 0 43.5 0 36.5625V11.4375C0 4.5 4.5 0 11.4375 0H36.5625Z",
    fill: "url(#paint0_linear_2522_17216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 26.0498L19.1509 23.2008L17.5999 24.7518L21.9999 29.1518L30.7999 20.3518L29.2489 18.8008L21.9999 26.0498Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 39.6008L17.2061 35.9785C15.2693 34.9481 13.6497 33.4098 12.5211 31.5287C11.3924 29.6475 10.7973 27.4945 10.7997 25.3008V11.0008C10.8002 10.4175 11.0322 9.85824 11.4447 9.44579C11.8571 9.03334 12.4164 8.80136 12.9997 8.80078H34.9997C35.583 8.80136 36.1422 9.03334 36.5547 9.44579C36.9671 9.85824 37.1991 10.4175 37.1997 11.0008V25.3008C37.202 27.4945 36.6069 29.6475 35.4782 31.5287C34.3496 33.4098 32.73 34.9481 30.7933 35.9785L23.9997 39.6008ZM12.9997 11.0008V25.3008C12.9978 27.0958 13.4849 28.8574 14.4085 30.3965C15.3321 31.9356 16.6575 33.1941 18.2423 34.037L23.9997 37.1071L29.7571 34.0381C31.342 33.1951 32.6675 31.9364 33.5911 30.3971C34.5147 28.8578 35.0017 27.096 34.9997 25.3008V11.0008H12.9997Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2522_17216",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64FA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fb69cc4c732a95ac419410095d3447d6.svg";
export { ForwardRef as ReactComponent };